<template>
    <b-form inline>
        <b-form-group
                      label="Name"
                      description="Filter name."
                      :label-cols="3"
                      :horizontal="true">
            <b-form-input type="text" placeholder="Enter Name.." v-model="search.name"></b-form-input>
        </b-form-group>
        <b-form-group
                label="Email"
                description="Filter Person Email."
                :label-cols="3"
                :horizontal="true">
            <b-form-input type="text" placeholder="Enter email.." v-model="search.email"></b-form-input>
        </b-form-group>
        <div slot="footer">
            <b-button type="button" size="sm" variant="primary" v-on:click="searchUsers" ><i class="fa fa-search" ></i> Search</b-button>
        </div>
    </b-form>
</template>

<script>
    import {RepositoryFactory} from "../../services/repositories/RepositoryFactory";

    const UsersRepo = RepositoryFactory.get('user')

    export default {
        name: 'users-search-form',
        data() {
            return {
                search: {
                    id: '',
                    name: '',
                    email: '',
                },
            }
        },
        methods: {
            searchUsers() {
                this.$emit('click')
                UsersRepo
                    .searchUsers(this.search)
                    .then(
                        response => (
                            this.$emit('change', response.data)
                        )
                    )
            },
        }
    }
</script>

<style>
    button {
        margin-right: 5px;
    }
    form {
        padding-bottom: 10px;
    }
</style>
